import { Injectable } from '@angular/core'
import { SidePanelService } from '@tv3/services/utils/side-panel.service'
import { MessageDialogComponent } from './message-dialog.component'

@Injectable()
export class MessageSidePanelService {
  constructor(private sidePanel: SidePanelService) {}

  open(inquiryId: string, messageId?: string) {
    return this.sidePanel.openSide(MessageDialogComponent, {
      data: { inquiryId, messageId },
      panelClass: ['modal-message-inquiries', 'modal', 'side-modal-lg', 'right'],
    })
  }
}
